import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import XHR from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

// 安全地获取 localStorage 中的语言设置
// const getSavedLanguage = (): string | null => {
//   if (typeof window === 'undefined' || typeof Storage === 'undefined') {
//     return null
//   }
//   try {
//     return localStorage.getItem('i18nextLng')
//   } catch (e) {
//     // Safari 私有浏览模式可能无法访问 localStorage
//     return null
//   }
// }

// const savedLanguage = getSavedLanguage()
// const defaultLanguage = savedLanguage || 'en'

i18next
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `./locales/{{lng}}.json`
    },
    react: {
      useSuspense: true
    },
    fallbackLng: 'en',
    lng: 'en', // 使用检测到的语言或默认英文
    // detection: {
    //   // 只从 localStorage 读取用户之前的选择，不自动检测浏览器语言
    //   order: ['localStorage'],
    //   caches: ['localStorage'],
    //   lookupLocalStorage: 'i18nextLng',
    //   // 如果 localStorage 中没有保存的语言，回退到 fallbackLng ('en')
    //   checkWhitelist: true
    // },
    preload: ['en', 'ko', 'fr', 'ja', 'zh-TW', 'vi', 'ar', 'de'],
    keySeparator: '.',
    interpolation: { escapeValue: false }
  } as any)

export default i18next
